import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { deleteSetupform } from 'actions/setupform'
import { redirectAbsolutePath } from 'utils/redirect'
import EventDraftListItem from './event-draft-list-item'

export class EventDraftListItemContainer extends Component {

  constructor(props) {
    super(props)

    this.handleCardClick = this.handleCardClick.bind(this)
    this.handleDeleteClick = this.handleDeleteClick.bind(this)
    this.handleLinkClick = this.handleLinkClick.bind(this)
  }

  handleCardClick() {
    const { externalUrl, url } = this.props

    if (externalUrl) {
      redirectAbsolutePath(url)
    } else {
      this.props.router.push(url)
    }
  }

  handleDeleteClick(e) {
    const { setupformId } = this.props

    // eslint-disable-next-line no-alert
    const confirm = window.confirm('Are you sure you want to remove the draft?')
    if (confirm) {
      this.props.deleteSetupform(setupformId)
    }

    e.stopPropagation()
  }

  handleLinkClick(e) {
    e.stopPropagation()
  }

  render() {
    return (
      <EventDraftListItem
        {...this.props}
        onCardClick={this.handleCardClick}
        onDeleteClick={this.handleDeleteClick}
        onLinkClick={this.handleLinkClick}
        url={this.props.url}
      />
    )
  }
}

EventDraftListItemContainer.propTypes = {
  deleteSetupform: PropTypes.func,
  externalUrl: PropTypes.bool,
  setupformId: PropTypes.number,
  url: PropTypes.string,
  router: PropTypes.object,
}

const mapDispatchToProps = { deleteSetupform }

export default connect(null, mapDispatchToProps)(withRouter(EventDraftListItemContainer))



/** WEBPACK FOOTER **
 ** ./src/components/event-draft-list-item/event-draft-list-item-container.js
 **/